/**
 * MARAVEL - Cart Drawer (vanilla JS AJAX)
 * Uses native fetch() against Shopify Cart API.
 * Exposes window.MaravelCart = { open, close, fetch, add, update }
 * Zero jQuery. Zero dependencies.
 */

(function () {
  'use strict';

  /* ─── Cross-sell (cart complementary item, discount applies automatically via active discount) ── */
  /* Liquid levert de live productdata (zie theme.liquid). De literal hieronder is
     alleen een vangnet als het product tijdelijk niet beschikbaar is; de image is
     daar bewust weggelaten omdat een vaste bestandsnaam precies de 404 veroorzaakte
     die dit blok eerder brak. */
  var CROSS_SELL = window.MARAVEL_CROSS_SELL || {
    productId: 11035917484369,
    variantId: 54623887524177,
    handle: 'cinturon-de-piel-fino',
    title: 'Cinturón Fino de Polipiel',
    image: '',
    price: 1995,
    comparePrice: 2995
  };

  function buildCrossSellHtml(cart) {
    if (!cart || !cart.items) return '';
    var alreadyInCart = cart.items.some(function (it) { return it.product_id === CROSS_SELL.productId; });
    if (alreadyInCart) return '';
    return '' +
      '<div class="mv-cart-crosssell">' +
        '<p class="mv-cart-crosssell__label">Complementa tu pedido</p>' +
        '<div class="mv-cart-crosssell__card">' +
          (CROSS_SELL.image
            ? '<a href="/products/' + CROSS_SELL.handle + '" class="mv-cart-crosssell__img">' +
                '<img src="' + CROSS_SELL.image + '" width="64" height="85" loading="lazy" alt="' + CROSS_SELL.title + '">' +
              '</a>'
            : '') +
          '<div class="mv-cart-crosssell__info">' +
            '<a href="/products/' + CROSS_SELL.handle + '" class="mv-cart-crosssell__title">' + CROSS_SELL.title + '</a>' +
            '<span class="mv-cart-crosssell__badge">-20% al añadirlo ahora</span>' +
            '<span class="mv-cart-crosssell__price"><s>' + formatMoney(CROSS_SELL.comparePrice) + '</s> ' + formatMoney(Math.round(CROSS_SELL.price * 0.8)) + '</span>' +
          '</div>' +
          '<button type="button" class="mv-cart-crosssell__add" data-cross-sell-add>Añadir</button>' +
        '</div>' +
      '</div>';
  }

  /* ─── Money formatting ──────────────────────────────────────────────────── */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' EUR';
  }

  /* ─── SVG icons ─────────────────────────────────────────────────────────── */
  const ICON_CLOSE = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;

  /* GOLDEN RULE: free shipping on ALL orders - no minimum. Threshold 0 hides the
     "faltan X para envío gratis" progress bar and makes the estimated shipping
     line always €0. Keep in sync with the real Shopify rate (Settings > Shipping
     and delivery must be €0 for every zone). */
  const FREE_SHIPPING_THRESHOLD = 0;
  const STANDARD_SHIPPING_RATE = 0;

  /* ─── State ──────────────────────────────────────────────────────────────── */
  let cartData = null;

  /* ─── DOM helpers ───────────────────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ─── Update all cart count badges ─────────────────────────────────────── */
  function updateCartBadges(count) {
    qsa('[data-mv-cart-count], .cart-count, .js-cart-count, .cart-link__bubble').forEach(el => {
      el.textContent = count > 0 ? String(count) : '';
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ─── Free-shipping progress bar (reusable - drawer + cart page) ────────── */
  function buildShippingBarHtml(cart) {
    // No threshold configured (free shipping always on) - nothing to show,
    // a progress bar toward a goal that's already always met is just noise.
    if (FREE_SHIPPING_THRESHOLD <= 0) return '';

    const remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
    const pct = Math.min(100, Math.round((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100));
    const achieved = remaining <= 0;

    const message = !achieved
      ? `Te faltan <strong>${formatMoney(remaining)}</strong> para el envío gratis`
      : `¡Envío gratis conseguido!`;

    return `
      <div class="mv-cart-shipping-bar${achieved ? ' is-achieved' : ''}">
        <p class="mv-cart-shipping-bar__label">${message}</p>
        <div class="mv-cart-shipping-bar__track">
          <div class="mv-cart-shipping-bar__fill" style="width:${pct}%"></div>
        </div>
      </div>`;
  }

  /* ─── Render cart items ──────────────────────────────────────────────────── */
  function buildItemsHtml(cart) {
    return cart.items.map(item => {
      const imageUrl = item.image
        ? item.image.replace(/\.(\w+)(\?|$)/, '_160x.$1$2')
        : '';

      var variantLabel = '';
      if (item.options_with_values && item.options_with_values.length) {
        variantLabel = item.options_with_values
          .filter(function (o) { return o.value && o.value !== 'Default Title'; })
          .map(function (o) { return o.name + ': ' + o.value; })
          .join(' · ');
      } else if (item.variant_title && item.variant_title !== 'Default Title') {
        variantLabel = item.variant_title;
      }
      const variantInfo = variantLabel
        ? `<div class="mv-cart-item__variant">${variantLabel}</div>`
        : '';

      const comparePrice = item.original_line_price !== item.line_price
        ? `<span style="font-size:11px;color:#A39A89;text-decoration:line-through;margin-left:6px;">${formatMoney(item.original_line_price)}</span>`
        : '';

      return `
        <div class="mv-cart-item" data-key="${item.key}">
          ${imageUrl
            ? `<img class="mv-cart-item__image" src="${imageUrl}" alt="${item.title}" loading="lazy">`
            : `<div class="mv-cart-item__image"></div>`
          }
          <div class="mv-cart-item__details">
            <div class="mv-cart-item__head">
              <a href="${item.url}" class="mv-cart-item__title">${item.product_title}</a>
              <div class="mv-cart-item__price">
                ${formatMoney(item.line_price)}${comparePrice}
              </div>
            </div>
            ${variantInfo}
            <div class="mv-cart-item__foot">
              <div class="mv-cart-item__qty">
                <button type="button" class="mv-qty-btn" data-action="decrease" data-key="${item.key}" aria-label="Disminuir cantidad">−</button>
                <span>${item.quantity}</span>
                <button type="button" class="mv-qty-btn" data-action="increase" data-key="${item.key}" aria-label="Aumentar cantidad">+</button>
              </div>
              <button type="button" class="mv-cart-item__remove" data-key="${item.key}">Quitar</button>
            </div>
          </div>
        </div>`;
    }).join('');
  }

  function buildFooterHtml(cart, opts) {
    const savingsHtml = cart.total_discount > 0
      ? `<div class="mv-cart-savings">Total ahorrado <span>${formatMoney(cart.total_discount)}</span></div>`
      : '';
    const viewCartLink = opts.showViewCartLink
      ? `<a href="/cart" style="display:block;text-align:center;margin-top:12px;font-size:11px;letter-spacing:.08em;text-decoration:underline;text-underline-offset:4px;color:var(--color-muted);">Ver la cesta</a>`
      : '';

    // Social proof + reassurance clustered around the checkout button (highest-converting spot)
    const drawerEl = document.getElementById('mv-cart-drawer');
    const happyNum = (drawerEl && drawerEl.dataset.happy) ? drawerEl.dataset.happy : '';
    const happyHtml = happyNum
      ? `<div class="mv-cart-happy">
           <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21s-7.5-4.9-10-9.2C.5 9 1.6 5.6 4.6 4.7c2-.6 3.9.3 4.9 1.9.4.6 1.6.6 2 0 1-1.6 2.9-2.5 4.9-1.9 3 .9 4.1 4.3 2.6 7.1C19.5 16.1 12 21 12 21z"/></svg>
           <span>Más de <strong>${happyNum}+</strong> clientas felices</span>
         </div>`
      : '';

    return `
      ${savingsHtml}
      <div class="mv-cart-subtotal">
        <span class="mv-cart-subtotal__label">Subtotal</span>
        <span class="mv-cart-subtotal__price">${formatMoney(cart.total_price)}</span>
      </div>
      ${happyHtml}
      <a href="/checkout" class="mv-cart-checkout"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Tramitar pedido</a>
      ${viewCartLink}
      <div class="mv-cart-trustrow">
        <span class="mv-cart-trustrow__item"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>Envío gratis</span>
        <span class="mv-cart-trustrow__item"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.5 15a9 9 0 1 0 2.1-9.4L1 10"/></svg>30 días</span>
        <span class="mv-cart-trustrow__item"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Pago seguro</span>
      </div>`;
  }

  /* ─── Cart page "Resumen" summary card ───────────────────────────────────── */
  function buildPageFooterHtml(cart) {
    const shippingCost = cart.total_price >= FREE_SHIPPING_THRESHOLD ? 0 : STANDARD_SHIPPING_RATE;
    const shippingLabel = shippingCost === 0 ? 'Gratis' : formatMoney(shippingCost);
    const total = cart.total_price + shippingCost;
    const savingsHtml = cart.total_discount > 0
      ? `<div class="mv-cart-savings">Total ahorrado <span>${formatMoney(cart.total_discount)}</span></div>`
      : '';

    return `
      <h2 class="mv-cart-page__summary-title">Resumen</h2>
      ${buildShippingBarHtml(cart)}
      ${savingsHtml}
      <div class="mv-cart-page__row">
        <span>Subtotal</span>
        <span>${formatMoney(cart.total_price)}</span>
      </div>
      <div class="mv-cart-page__row">
        <span>Envío</span>
        <span>${shippingLabel}</span>
      </div>
      <form id="mv-cart-coupon-form" class="mv-cart-page__coupon">
        <input type="text" name="discount" placeholder="Código promocional" autocomplete="off">
        <button type="submit">Aplicar</button>
      </form>
      <div class="mv-cart-page__row mv-cart-page__row--total">
        <span>Total</span>
        <span>${formatMoney(total)}</span>
      </div>
      <a href="/checkout" class="mv-cart-checkout"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Tramitar pedido</a>`;
  }

  function bindCouponForm() {
    const form = qs('#mv-cart-coupon-form');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = 'true';
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const code = form.discount.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    });
  }

  function bindItemControls(container, cart) {
    container.querySelectorAll('.mv-qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const key    = btn.dataset.key;
        const action = btn.dataset.action;
        const item   = cart.items.find(i => i.key === key);
        if (!item) return;
        const newQty = action === 'increase' ? item.quantity + 1 : item.quantity - 1;
        MaravelCart.update(key, Math.max(0, newQty));
      });
    });

    container.querySelectorAll('.mv-cart-item__remove').forEach(btn => {
      btn.addEventListener('click', () => MaravelCart.update(btn.dataset.key, 0));
    });
  }

  function bindCrossSellButton(container) {
    const btn = container.querySelector('[data-cross-sell-add]');
    if (!btn) return;
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      btn.textContent = 'Añadiendo…';
      await addToCart(CROSS_SELL.variantId, 1);
      await fetchCart();
    });
  }

  function renderInto(bodySel, footerSel, barSel, headSel, cart, opts) {
    const body = qs(bodySel);
    const footer = qs(footerSel);
    const bar = barSel ? qs(barSel) : null;
    const head = headSel ? qs(headSel) : null;
    if (!body) return;

    if (head) head.textContent = cart && cart.item_count > 0 ? `Tu cesta (${cart.item_count})` : 'Tu cesta';

    if (!cart || cart.item_count === 0) {
      body.innerHTML = `
        <div class="mv-cart-drawer__empty">
          <div class="mv-cart-drawer__empty-title">La cesta está vacía</div>
          <p>Descubre nuestra colección y añade tus piezas favoritas.</p>
        </div>`;
      if (footer) footer.innerHTML = '';
      if (bar) bar.innerHTML = '';
      return;
    }

    if (bar) bar.innerHTML = buildShippingBarHtml(cart);
    body.innerHTML = buildItemsHtml(cart) + buildCrossSellHtml(cart);
    bindItemControls(body, cart);
    bindCrossSellButton(body);
    if (footer) {
      footer.innerHTML = opts.pageStyle ? buildPageFooterHtml(cart) : buildFooterHtml(cart, opts);
      if (opts.pageStyle) bindCouponForm();
    }
  }

  function renderCartItems(cart) {
    renderInto('#mv-cart-body', '#mv-cart-footer', '#mv-cart-shipping-bar', '#mv-cart-drawer-title', cart, { showViewCartLink: true });
    renderInto('#mv-cart-page-body', '#mv-cart-page-footer', null, null, cart, { pageStyle: true });
  }

  /* ─── Fetch cart from Shopify ───────────────────────────────────────────── */
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js', {
        headers: { 'Content-Type': 'application/json' }
      });
      if (!res.ok) throw new Error('Cart fetch failed');
      cartData = await res.json();
      updateCartBadges(cartData.item_count);
      renderCartItems(cartData);
      return cartData;
    } catch (err) {
      console.error('[maravel-cart] fetchCart error', err);
      return null;
    }
  }

  /* ─── Add to cart ───────────────────────────────────────────────────────── */
  async function addToCart(variantId, quantity, properties) {
    quantity = quantity || 1;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: properties || {}
        })
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Add to cart failed');
      }
      const item = await res.json();
      await fetchCart();
      MaravelCart.open();
      return item;
    } catch (err) {
      console.error('[maravel-cart] addToCart error', err);
      throw err;
    }
  }

  /* ─── Update quantity ───────────────────────────────────────────────────── */
  async function updateCart(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      if (!res.ok) throw new Error('Cart update failed');
      await fetchCart();
    } catch (err) {
      console.error('[maravel-cart] updateCart error', err);
    }
  }

  /* ─── Drawer open / close ───────────────────────────────────────────────── */
  function openDrawer() {
    const drawer  = qs('#mv-cart-drawer');
    const overlay = qs('#mv-cart-overlay');
    if (!drawer) return;
    fetchCart();
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    const drawer  = qs('#mv-cart-drawer');
    const overlay = qs('#mv-cart-overlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
  }

  /* ─── Public API ────────────────────────────────────────────────────────── */
  window.MaravelCart = {
    open:   openDrawer,
    close:  closeDrawer,
    fetch:  fetchCart,
    add:    addToCart,
    update: updateCart
  };

  /* ─── ATC form interception ─────────────────────────────────────────────── */
  function bindAtcForms() {
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!form.matches('[action*="/cart/add"], .product-single__form')) return;

      // Only intercept if cart type is 'drawer' or we have the drawer element
      if (!qs('#mv-cart-drawer')) return;

      e.preventDefault();

      const idInput = form.querySelector('[name="id"], [data-product-select]');
      if (!idInput) return;

      const variantId = idInput.value;
      const qtyInput  = form.querySelector('[name="quantity"]');
      const quantity  = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      // Collect properties
      const properties = {};
      form.querySelectorAll('[name^="properties"]').forEach(input => {
        const key = input.name.replace(/^properties\[(.+)\]$/, '$1');
        properties[key] = input.value;
      });

      const btn = form.querySelector('[data-add-to-cart]');
      if (btn) {
        btn.setAttribute('data-loading', 'true');
        btn.style.opacity = '0.7';
      }

      try {
        await addToCart(variantId, quantity, properties);
      } catch (err) {
        // Surface error to user
        alert(err.message || 'No se pudo añadir el artículo. Inténtalo de nuevo.');
      } finally {
        if (btn) {
          btn.removeAttribute('data-loading');
          btn.style.opacity = '';
        }
      }
    });
  }

  /* ─── Wire up cart icon buttons ─────────────────────────────────────────── */
  function bindCartTriggers() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-mv-cart-open], .js-drawer-open-cart, [href="/cart"]');
      if (!trigger) return;
      if (trigger.href && !trigger.dataset.mvCartOpen && !trigger.classList.contains('js-drawer-open-cart')) return;
      e.preventDefault();
      openDrawer();
    });

    const closeBtn = qs('#mv-cart-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    const overlay = qs('#mv-cart-overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ─── Boot ───────────────────────────────────────────────────────────────── */
  function init() {
    fetchCart(); // warm the badge on page load
    bindAtcForms();
    bindCartTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ─── Patch Motion's CartForm custom element ────────────────────────────────
   Motion v8 registers <cart-form> and calls cartMarkup() on load. When the
   cart-drawer section is not rendered (we use our own drawer), the method
   tries to access classList on a null querySelector result and throws.
   We wrap the method with a try/catch after the element class is defined.    */
if (typeof customElements !== 'undefined' && customElements.whenDefined) {
  customElements.whenDefined('cart-form').then(function () {
    var Cls = customElements.get('cart-form');
    if (Cls && Cls.prototype && typeof Cls.prototype.cartMarkup === 'function') {
      var _orig = Cls.prototype.cartMarkup;
      Cls.prototype.cartMarkup = function () {
        try { return _orig.apply(this, arguments); } catch (e) { /* no cart-form in DOM */ }
      };
    }
  });
}
